export default __webpack_public_path__ + "64d7b79c0d727665b4c4bc2ea15e800a.png";